import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import { authLogin, updateToken, userInfo, forgotPassword as forgotPasswordApi, resetPassword as resetPasswordApi } from "../../app/api";
import { ExceptionMap } from "antd/es/result";
import { Link, redirect, useNavigate } from "react-router-dom";
import EeljCountdown from "../eelj/EeljCountdown";

const Login = () => {
  const navigate = useNavigate();
  const {userBio, setUserBio, handleLogin, eeljuud} = useContext(UserContext);

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotPasswordError, setForgotPasswordError] = useState("");
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState<string>("");

  const [verifyOTP, setVerifyOTP] = useState(false);
  const [tokenOTP, setTokenOTP] = useState("");
  const [resetPasswordError, setResetPasswordError] = useState("");
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState(false);
  const [resetPassword, setResetPassword] = useState("");
  const [resetPasswordVerify, setResetPasswordVerify] = useState("");

  const [error, setError] = useState(false);

  const Login = useCallback(async () => {
    setError(false);
    try {
      const loggedIn = await handleLogin(phone, password);
      navigate('/');
    } catch(err) {
      setError(true);
    }
  }, [phone, password]);

  const requestOTP = useCallback(async () => {
    setForgotPasswordError('');
    try {
      const resp = await forgotPasswordApi({email: forgotPasswordEmail});
      setVerifyOTP(true);
    } catch(err) {
      setForgotPasswordError('Бүртгэлтэй хэрэглэгч олдсонгүй.');
    }
  }, [forgotPasswordEmail]);

  const handleResetPassword = useCallback(async () => {
    setResetPasswordError('');
    setResetPasswordSuccess(false);

    if(resetPassword !== resetPasswordVerify) {
      setResetPasswordError('Нүүц үг зөрж байна.');
      return;
    }

    try {
      const resp = await resetPasswordApi(
        {
          password: resetPassword,
          password_confirmation: resetPasswordVerify,
        },
        tokenOTP
      );

      setResetPasswordSuccess(true);
    } catch(err: any) {
      setResetPasswordError('Батлагаажуулах код буруу эсвэл хугацаа дууссан байна.');
    }
  }, [resetPassword, resetPasswordVerify, tokenOTP]);

  return (
    <div className="min-h-screen p-6 md:p-24 pt-[96px] flex flex-col items-center justify-center ">
      <div className="absolute left-0 top-0 bottom-0 lg:right-[50%] right-0 -z-50">
        <img
          className="h-full w-full"
          src="/bg.png"
          alt=""
          width={697}
          height={443}
        />
      </div>
      <div className="px-6 py-4 md:py-12 md:px-12 bg-transparent text-gray-800 text-center lg:text-left">
        <div className="container mx-auto xl:px-32">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="mt-3 md:mt-12 lg:mt-0">
              {eeljuud.activeEelj[0] ?
                <EeljCountdown {...eeljuud.activeEelj[0]}/>
                :
                <div>
                  <h1 className="text-lg text-gray-900 md:text-3xl italic font-bold">
                    Олон улсын хүүхдийн Найрамдал цогцолборт тавтай морил!
                  </h1>
                </div>
              }
            </div>
            <div className="mb-12 lg:mb-0">
              <div className="block bg-white px-6 py-4 md:py-12 md:px-12">
                <form>
                  {
                    forgotPassword ?
                    <>
                    {
                      verifyOTP ?
                      <>
                        {resetPasswordError && (
                          <div
                            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                            role="alert"
                          >
                            <span className="block sm:inline">
                              {resetPasswordError}
                            </span>
                          </div>
                        )}
                        {resetPasswordSuccess && (
                          <div
                            className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative cursor-pointer"
                            role="alert"
                            onClick={() => {
                              setForgotPassword(false);
                              setVerifyOTP(false);
                            }}
                          >
                            <span className="block sm:inline underline ">
                              Нүүц үг амжилттай сэргээгдлээ. Энд дарж нэвтэрнэ үү.
                            </span>
                          </div>
                        )}
                        <div className="pt-10">
                          <span className="block text-sm font-bold text-[#001447] mb-2">
                            Бүртгэлтэй и-мэйлд ирсэн баталгаажуулах кодыг оруулна уу.
                          </span>
                          <input
                            value={tokenOTP}
                            type="text"
                            className="form-control block w-full px-3 py-1.5 mb-6 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            placeholder="Батлагаажуулах код"
                            onChange={(e) => setTokenOTP(e.target.value)}
                          />
                        </div>
                        <div className="pt-10">
                          <span className="block text-sm font-bold text-[#001447] mb-2">
                            Шинэ нууц үг (4 оронтой пин код)
                          </span>
                          <input
                            value={resetPassword}
                            type="password"
                            className="form-control block w-full px-3 py-1.5 mb-6 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            placeholder="****"
                            minLength={4}
                            maxLength={4}
                            onChange={(e) => setResetPassword(e.target.value)}
                          />
                        </div>
                        <div className="pt-10">
                          <span className="block text-sm font-bold text-[#001447] mb-2">
                            Шинэ нууц үгээ давтана уу
                          </span>
                          <input
                            value={resetPasswordVerify}
                            type="password"
                            className="form-control block w-full px-3 py-1.5 mb-6 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            placeholder="****"
                            minLength={4}
                            maxLength={4}
                            onChange={(e) => setResetPasswordVerify(e.target.value)}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={(e) => {e.preventDefault(); handleResetPassword();}}
                          data-mdb-ripple="true"
                          data-mdb-ripple-color="light"
                          className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white inline-block mb-4 w-full"
                        >
                          Нүүц үг сэргээх
                        </button>
                      </>
                      :
                      <>
                        {forgotPasswordError && (
                          <div
                            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                            role="alert"
                          >
                            <span className="block sm:inline">
                              {forgotPasswordError}
                            </span>
                          </div>
                        )}
                        <div className="pt-10">
                          <span className="block text-sm font-bold text-[#001447] mb-2">
                            Бүртгэлтэй и-мэйл хаягаа оруулна уу.
                          </span>
                          <input
                            value={forgotPasswordEmail}
                            type="email"
                            className="form-control block w-full px-3 py-1.5 mb-6 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            placeholder="И-мэйл хаяг"
                            onChange={(e) => setForgotPasswordEmail(e.target.value)}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={(e) => {e.preventDefault(); requestOTP();}}
                          data-mdb-ripple="true"
                          data-mdb-ripple-color="light"
                          className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white inline-block mb-4 w-full"
                        >
                          Нүүц үг сэргээх код авах
                        </button>
                      </>
                    }
                      <p
                        className="mt-2 text-center text-[#D0D2D6] cursor-pointer"
                        onClick={() => {
                          setForgotPassword(false);
                          setVerifyOTP(false);
                        }}
                      >
                        Буцах
                      </p>
                    </>
                    :
                    <>
                      {error && (
                        <div
                          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                          role="alert"
                        >
                          <span className="block sm:inline">
                            Утасны дугаар эсвэл нууц үг буруу байна
                          </span>
                        </div>
                      )}
                      <div className="pt-10">
                        <span className="block text-sm font-bold text-[#001447] mb-2">
                          Утасны дугаар
                        </span>
                        <input
                          value={phone}
                          type="text"
                          className="form-control block w-full px-3 py-1.5 mb-6 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          placeholder="Утасны дугаар"
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                      <div>
                        <span className="block text-sm font-bold text-[#001447] mb-2">
                          Нууц үг (4 оронтой пин код)
                        </span>
                        <input
                          value={password}
                          type="password"
                          className="form-control block w-full px-3 py-1.5 mb-6 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          placeholder="Нууц үг"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={(e) => {e.preventDefault(); Login();}}
                        data-mdb-ripple="true"
                        data-mdb-ripple-color="light"
                        className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white inline-block mb-4 w-full"
                      >
                        Нэвтрэх
                      </button>
                      <div className="mb-4 text-center text-[#D0D2D6]">
                        <p>эсвэл</p>
                      </div>
                      <Link to={'/register'}>
                        <button
                          type="button"
                          data-mdb-ripple="true"
                          data-mdb-ripple-color="light"
                          className="rounded-full border border-[#07B2EC] px-6 py-2 text-sm font-semibold text-[#07B2EC] w-full"
                          >
                          Бүртгүүлэх
                        </button>
                      </Link>
                      <p
                        className="mt-2 text-center text-[#D0D2D6] cursor-pointer"
                        onClick={() => setForgotPassword(true)}
                      >
                        Нууц үг мартсан?
                      </p>
                    </>
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;